// 1. 创建一个新的axios实例
// 2. 请求拦截器，如果有token进行头部携带
// 3. 响应拦截器：1. 剥离无效数据  2. 处理token失效
// 4. 导出一个函数，调用当前的axsio实例发请求，返回值promise

import axios from 'axios'
import router from '@/router'
import {getLocal} from "@/utils/localstorage";

// 导出基准地址，原因：其他地方不是通过axios发请求的地方用上基准地址
// export const baseURL = 'http://pcapi-xiaotuxian-front-devtest.itheima.net/'
const instance = axios.create({
    // axios 的一些配置，baseURL  timeout
    baseURL: '/api',
    timeout: 5000
})

instance.interceptors.request.use(config => {
    // 判断是否为搜索文章的请求
    const isSearchRequest = config.url.includes('/questionApi/searchQuestionListonList');
    if (!isSearchRequest) {
        // 拦截业务逻辑
        // 进行请求配置的修改
        // 如果本地又token就在头部携带
        // 1. 获取用户信息对象
        // 2. 判断是否有token
        let token = getLocal('Authorization');
        if (token) {
            // 3. 设置token
            config.headers.Authorization = `${token}`
        }

        // 统一请求头
        config.headers['token'] = window.localStorage.getItem('token');
    }

    return config
}, err => {
    return Promise.reject(err)
})

// res => res.data  取出data数据，将来调用接口的时候直接拿到的就是后台的数据
instance.interceptors.response.use(res => {
    if(res.data.code == 2001){
        window.location.href = "http://localhost:8081/"
    }
    // 314 状态码 身份认证异常
    if (res.data.code == 314) {
        window.location.href = "http://localhost:8081/"
    }
    return res.data;
}, err => {
    // 401 状态码，进入该函数
    if (err.response && err.response.status === 401) {
        // 1. 清空无效用户信息
        // 2. 跳转到登录页
        // 3. 跳转需要传参（当前路由地址）给登录页码
        // 当前路由地址
        // 组件里头：`/user?a=10` $route.path === /user  $route.fullPath === /user?a=10
        // js模块中：router.currentRoute.value.fullPath 就是当前路由地址，router.currentRoute 是ref响应式数据
        const fullPath = encodeURIComponent(router.currentRoute.value.fullPath)
        // encodeURIComponent 转换uri编码，防止解析地址出问题
        router.push('/login?redirectUrl=' + fullPath)
        return Promise.reject(err)
    }
    if (err && err.status === 500) {
        if (err.data.message === 'Authorization失效，请重新登录') {
            // 清除本地存储的 token
            localStorage.removeItem('Authorization');

            // 跳转到登录页面
            router.push({ name: 'Login' });

            // 显示提示信息
            return Promise.reject(new Error('登录状态已过期，请重新登录'));
        }
    }

    return Promise.reject(err)
})

// 请求工具函数
export default (url, method, submitData) => {
    // 负责发请求：请求地址，请求方式，提交的数据
    return instance({
        url,
        method,
        // 1. 如果是get请求  需要使用params来传递submitData   ?a=10&c=10
        // 2. 如果不是get请求  需要使用data来传递submitData   请求体传参
        // [] 设置一个动态的key, 写js表达式，js表达式的执行结果当作KEY
        // method参数：get,Get,GET  转换成小写再来判断
        // 在对象，['params']:submitData ===== params:submitData 这样理解
        [method.toLowerCase() === 'get' ? 'params' : 'data']: submitData
    })
}

export function get(url, param) {
    // 负责发请求：请求地址，请求方式，提交的数据
    return instance({
        url: url,
        method: 'GET',
        params: param
    })
}

export function post(url, data) {
    // 负责发请求：请求地址，请求方式，提交的数据
    return instance({
        url: url,
        method: 'POST',
        data: data
    })
}

export function put(url, data) {
    // 负责发请求：请求地址，请求方式，提交的数据
    return instance({
        url: url,
        method: 'PUT',
        data: data
    })
}

export function del(url, data) {
    // 负责发请求：请求地址，请求方式，提交的数据
    return instance({
        url: url,
        method: 'DELETE',
        data: data
    })
}